// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6j7RoO96x{display:flex;flex-direction:column;align-items:center;width:100%;background-color:white}._3SCeMOkFx{display:flex;flex-direction:column;background-color:#cb2e63;align-items:center;position:relative;width:100%}._1R5OBvnQx{position:absolute;left:20px;top:16px}.ElukxgD7x{margin:10px;border-radius:40px}._1cgTS5iSx{margin-top:32px;text-align:center;padding:0px 20px}._6vDl81anx{margin:8px}._2Y2mja2Zx{max-width:300px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"top-container": "_6j7RoO96x",
	"topContainer": "_6j7RoO96x",
	"image-container": "_3SCeMOkFx",
	"imageContainer": "_3SCeMOkFx",
	"close-button": "_1R5OBvnQx",
	"closeButton": "_1R5OBvnQx",
	"install-button": "ElukxgD7x",
	"installButton": "ElukxgD7x",
	"status-container": "_1cgTS5iSx",
	"statusContainer": "_1cgTS5iSx",
	"status-title": "_6vDl81anx",
	"statusTitle": "_6vDl81anx",
	"status-subtitle": "_2Y2mja2Zx",
	"statusSubtitle": "_2Y2mja2Zx"
};
module.exports = exports;
